"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapInfoPageMenu = function mapInfoPageMenu(response) {
  if (!response) return false;
  return {
    content: response.data.body.map(function (option) {
      return {
        label: option.items && option.items[0].title[0].text,
        url: option.items && option.items[0].url_type === "local" ? option.items[0].url.url.replace("https://", "") : option.items[0].url.url,
        url_type: option.items && option.items[0].url_type
      };
    })
  };
};
var _default = mapInfoPageMenu;
exports["default"] = _default;